import { createTrackingConfig } from '../../../components/generic/labels';
import { getDateFormat, tableConfig, uiConfig } from '../../../config/appConfig';
import CustomMyManualsSplitView from './CustomMyManualsSplitView';
import { MANUAL_ENTITY_TYPE_ID } from '../manualConfig';

export const myManualsConfig = {
  entityName: 'My Manual',

  listScope: null,

  entityTypeId: MANUAL_ENTITY_TYPE_ID,

  api: {
    baseEndpoint: '/manual-assignment/me',
    endpoints: {
      list: '',
      getById: (id) => `/${id}`,
    },
    lookupEndpoints: {},
    swrInvalidation: {
      mainList: '/manual-assignment/me',
    },
  },

  ui: {
    drawerWidth: '30%',
    defaultPageSize: tableConfig.defaultPageSize,
    pageSizeOptions: tableConfig.pageSizeOptions,
    defaultTableDensity: tableConfig.defaultDensity,
    requiredFieldStyle: uiConfig.requiredFieldStyle,
    tableVariant: 'default',
    splitView: true,
    searchInputMaxWidth: uiConfig.searchInputMaxWidth,
    showViewButton: true,
    showEditButton: false,
    showDeleteButton: false,
    showActionsColumn: true,
    showAddButton: false,
  },

  features: {
    fileAttachments: true,
    masterEntityTypeId: MANUAL_ENTITY_TYPE_ID,
    approvalRequests: false,
    fileAttachmentEntityIdField: 'manualId',
  },

  customSplitViewPanel: {
    enabled: true,
    component: CustomMyManualsSplitView,
  },

  canEdit: () => false,
  canDelete: () => false,

  fields: [
    { name: 'id', label: 'Assignment ID', type: 'hidden', table: false, filterable: false },
    {
      name: 'code',
      label: 'Code',
      type: 'text',
      table: { header: 'Code', width: '120px', sortable: true },
      filterable: true,
    },
    {
      name: 'title',
      label: 'Title',
      type: 'text',
      table: { header: 'Title', width: '280px', sortable: true },
      filterable: true,
    },
    {
      name: 'manualTypeName',
      label: 'Type',
      type: 'text',
      table: { header: 'Type', width: '140px', sortable: true },
      filterable: false,
    },
    {
      name: 'departmentLabels',
      label: 'Departments',
      type: 'text',
      table: { header: 'Departments', width: '160px', sortable: false },
      filterable: false,
    },
    {
      name: 'manualStatusLabel',
      label: 'Manual status',
      type: 'text',
      table: {
        header: 'Status',
        width: '110px',
        sortable: true,
        displayField: 'manualStatusLabel',
        cellRenderer: 'badge',
      },
      filterable: false,
    },
    {
      name: 'assignedAt',
      label: 'Assigned Date',
      type: 'date',
      table: {
        header: 'Assigned Date',
        width: tableConfig.dateColumnWidth,
        sortable: true,
        cellRenderer: 'date',
        dateFormat: getDateFormat('table'),
      },
      filterable: false,
    },
    {
      name: 'viewStatusLabel',
      label: 'Your status',
      type: 'text',
      table: {
        header: 'Your status',
        width: '110px',
        sortable: true,
        displayField: 'viewStatusLabel',
        cellRenderer: 'badge',
      },
      filterable: false,
    },
    {
      name: 'viewedAt',
      label: 'Acknowledged Date',
      type: 'date',
      table: {
        header: 'Acknowledged Date',
        width: tableConfig.dateColumnWidth,
        sortable: true,
        cellRenderer: 'date',
        dateFormat: getDateFormat('table'),
      },
      filterable: false,
    },
    {
      name: 'fileAttachments',
      label: 'Files',
      type: 'label',
      table: {
        header: 'Files',
        width: '80px',
        sortable: false,
        displayField: 'fileAttachments',
        cellRenderer: 'myApprovalsFileCount',
      },
      filterable: false,
    },
    { name: 'canView', label: 'Can view', type: 'hidden', table: false, filterable: false },
    { name: 'manualId', label: 'Manual ID', type: 'hidden', table: false, filterable: false },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
      table: false,
      filterable: false,
    },
  ],

  get tableColumns() {
    return this.fields
      .filter((field) => field.table !== false && field.table)
      .map((field) => ({
        key: field.table.displayField || field.name,
        header: field.table.header || field.label,
        width: field.table.width || 'auto',
        sortable: field.table.sortable !== false,
        displayField: field.table.displayField || field.name,
        cellRenderer: field.table.cellRenderer || 'default',
        originalField: field.name,
      }));
  },

  exportFileName: 'my_manuals',

  get filterableFields() {
    return this.fields.filter((f) => f.filterable).map((f) => f.name);
  },

  filterGroups: [
    {
      name: 'basic',
      label: 'Basic',
      icon: '🔍',
      fields: ['title', 'code'],
    },
  ],

  formSections: [
    {
      title: 'Manual',
      icon: '📄',
      layout: 'grid',
      gridCols: 'md:grid-cols-12',
      fields: ['code', 'title', 'description', 'manualTypeName', 'departmentLabels'],
      fieldSpans: {
        code: 'md:col-span-4',
        title: 'md:col-span-8',
        description: 'md:col-span-12',
      },
    },
    {
      title: 'Assignment',
      icon: '📋',
      layout: 'grid',
      gridCols: 'md:grid-cols-2',
      fields: ['manualStatusLabel', 'viewStatusLabel', 'assignedAt', 'viewedAt'],
    },
  ],

  trackingSection: createTrackingConfig('My Manuals'),

  labels: {
    pageTitle: 'My Manuals',
    pageSubtitle:
      'Manuals assigned to you. Open a row to view details and files, then acknowledge.',
    noSelectionText: 'Select a manual to view details and files',
    viewTitle: 'Manual details',
  },

  pageHeader: {
    title: 'My Manuals',
    subtitle:
      'Open a manual, review details and attachments, then click Acknowledge. Your status changes from Pending to Viewed.',
  },
};

export default myManualsConfig;
